import { List, Map as MapIcon } from '@mui/icons-material';
import { Button, styled } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { TrackCommunityEvent } from '$analytics/useTrackAnalytics/domains/community/events';
import { useTrackCommunityAnalytics } from '$analytics/useTrackAnalytics/domains/community/useTrackCommunityAnalytics';

const RoundButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(3),
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: theme.palette.other.spaceCadet,
  borderRadius: '45px',
  '&:hover': {
    backgroundColor: theme.palette.other.spaceCadet,
  },
}));

interface Props {
  showList: boolean;
  toggleVisibility: () => unknown;
}

export const MapListToggle = ({ showList, toggleVisibility }: Props) => {
  const isMobile = useIsMobile('md');
  const trackEvent = useTrackCommunityAnalytics();

  if (!isMobile) {
    return null;
  }
  return (
    <RoundButton
      variant="contained"
      onClick={() => {
        toggleVisibility();
        trackEvent(TrackCommunityEvent.PartnerMapListMapToggleClick, {
          eventTarget: `${showList ? 'map' : 'list'}_view_button`,
        });
      }}
      startIcon={showList ? <MapIcon /> : <List />}
    >
      {showList ? 'Map' : 'List'}
    </RoundButton>
  );
};
